export const connectHostname = "wss://connect-open.airmessage.org";

export const googleApiKey = "AIzaSyDA10yp6zFHqpgzB6_tc7yh-ZNTUnrStMk";
export const googleClientID = "612127866489-tsc4jat1huvubm0gn0mtraflevdmgrbs.apps.googleusercontent.com";
export const googleClientSecret = "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";

export const firebaseConfig = {
	apiKey: "AIzaSyCshGZQcTfzyi_Di4H8_7wE2m6BkFYvIsU",
	authDomain: "airmessagev2-fa8aa.firebaseapp.com",
	projectId: "airmessagev2-fa8aa",
	storageBucket: "airmessagev2-fa8aa.firebasestorage.app",
	messagingSenderId: "286867129687",
	appId: "1:286867129687:web:8992ae2fc0199bf172aa12"
  };

export const sentryDSN = undefined;

export const jwkLocalEncryption: JsonWebKey = {
	kty: "oct",
	k: "s9lDeHtl0rh-3FpBDZwQvw",
	alg: "A128GCM"
};